import React, { useEffect } from 'react';
import './Modal.css';

export default function Modal({ isOpen, onClose, title, wide = false, children }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className={`modal-content${wide ? " modal-content--wide" : ""}`}>
        {title ? (
          <div className="modal-header">
            <h2>{title}</h2>
            <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
          </div>
        ) : (
          <button className="modal-close modal-close--floating" onClick={onClose} aria-label="Close">×</button>
        )}
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}
